import React from 'react';
import { Row, Column, FormInput, TextLinkParser } from 'Shared/components';
import { useFormikContext } from 'formik';
import { CoveredPartyPayloadType } from '@clearcover/core-app-types';
import { STATE_OPTIONS } from 'Shared/constants/states';
import { CASE_NUMBER_LOOKUP_URL } from 'Shared/constants/common';

import styles from './styles.module.css';

export const FinancialResponsibilityCertificate = () => {
  const { handleBlur, setFieldValue, values, errors } =
    useFormikContext<CoveredPartyPayloadType>();

  const selectedValue = values.cfrs?.[0] ?? {};

  const required = !!selectedValue?.required;
  const type = selectedValue?.type;
  const caseNumber = selectedValue?.caseNumber;
  const state = selectedValue?.state;

  return (
    <div className={styles.section} data-testid="driver-modal-license">
      <div className={styles.heading}>
        <h1>Certificate of Financial Responsibility (SR-22/FR-44)</h1>
        <TextLinkParser
          showIcon
          text={`If the customer needs assistance looking up their case number, [click here|${CASE_NUMBER_LOOKUP_URL}]`}
        />
      </div>
      <Row className="fs-exclude">
        <Column variant="third">
          <FormInput
            variant="radioButtonGroup"
            name="required"
            data-testid="cfr-required"
            onChange={(value: string) =>
              setFieldValue('cfrs[0].required', value === 'true')
            }
            onBlur={handleBlur}
            value={required?.toString()}
            label="Customer notified to file SR22/FR44"
            options={{ true: 'Yes', false: 'No' }}
          />
        </Column>
        <Column variant="third">
          <FormInput
            variant="radioButtonGroup"
            name="type"
            data-testid="cfr-type"
            onChange={(value: string) => setFieldValue('cfrs[0].type', value)}
            onBlur={handleBlur}
            value={type}
            label="Which certificate?"
            options={{ SR22: 'SR-22', FR44: 'FR-44' }}
            disabled={!required}
            required={required}
            radioGroupClassName={styles.upperCase}
            errorMessage={errors.cfrs?.[0]?.type}
          />
        </Column>
        <Column variant="third">
          <FormInput
            variant="text"
            name="caseNumber"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFieldValue('cfrs[0].caseNumber', e.target.value)
            }
            onBlur={handleBlur}
            value={caseNumber}
            label="Case Number"
            data-testid="cfr-case-number"
            disabled={!required}
            required={required}
            errorMessage={errors.cfrs?.[0]?.caseNumber}
          />
        </Column>
      </Row>
      <Row className="fs-exclude">
        <Column variant="third">
          <FormInput
            variant="selectAutocomplete"
            name="state"
            data-testid="cfr-state"
            onChange={(value: string) => {
              setFieldValue('cfrs[0].state', value);
            }}
            onBlur={handleBlur}
            value={state}
            errorMessage={errors.cfrs?.[0]?.state}
            label="SR-22/FR-44 Issue State"
            options={STATE_OPTIONS}
            required={required}
            disabled={!required}
          />
        </Column>
      </Row>
    </div>
  );
};
